{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Πρότυπα",
    "DESCRIPTION": "Δείτε τα πρότυπα μηνυμάτων που συγχρονίστηκαν από τα κιβώτια WhatsApp σας. Για να δημιουργήσετε ή να επεξεργαστείτε ένα πρότυπο, διαχειριστείτε το μέσω του παρόχου σας.",
    "COUNT": "{n} πρότυπο | {n} πρότυπα",
    "LEARN_MORE": "Μάθετε περισσότερα για τα πρότυπα WhatsApp",
    "SYNC_TEMPLATES": "Συγχρονισμός προτύπων",
    "SYNC_SUCCESS": "Ο συγχρονισμός προτύπων ξεκίνησε για όλα τα κιβώτια WhatsApp. Οι ενημερώσεις ενδέχεται να χρειαστούν μερικά λεπτά.",
    "PARTIAL_SYNC_ERROR": "Ο συγχρονισμός προτύπων ξεκίνησε για ορισμένα κιβώτια WhatsApp, αλλά για άλλα δεν ήταν δυνατός ο συγχρονισμός.",
    "SYNC_ERROR": "Δεν ήταν δυνατή η έναρξη συγχρονισμού προτύπων. Παρακαλώ προσπαθήστε ξανά.",
    "SEARCH_PLACEHOLDER": "Αναζήτηση με βάση το περιεχόμενο ή το όνομα...",
    "MANAGE_IN_META": "Διαχείριση στο Meta",
    "LOADING": "Φόρτωση προτύπων WhatsApp...",
    "EMPTY": "Δεν βρέθηκαν πρότυπα WhatsApp.",
    "NO_RESULTS": "Κανένα πρότυπο δεν ταιριάζει με τα φίλτρα σας.",
    "FETCH_ERROR": "Δεν ήταν δυνατή η φόρτωση των προτύπων WhatsApp. Παρακαλώ προσπαθήστε ξανά.",
    "PARTIAL_FETCH_ERROR": "Ορισμένα πρότυπα WhatsApp δεν ήταν δυνατό να φορτωθούν. Παρακαλώ προσπαθήστε ξανά.",
    "LAST_SYNC_ATTEMPT": "Τελευταία προσπάθεια συγχρονισμού στις {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Δεν έχει υποβληθεί για έγκριση WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Όλα τα κιβώτια",
      "ALL_LANGUAGES": "Όλες οι γλώσσες",
      "ALL_TYPES": "Όλοι οι τύποι"
    },
    "TYPES": {
      "TEXT": "Κείμενο",
      "IMAGE": "Εικόνα",
      "VIDEO": "Βίντεο",
      "DOCUMENT": "Έγγραφο",
      "CALL_TO_ACTION": "Κάλεσμα σε δράση",
      "COPY_CODE": "Αντιγραφή κωδικού"
    },
    "PREVIEW": {
      "TITLE": "Προεπισκόπηση προτύπου",
      "DESCRIPTION": "Δείτε πώς εμφανίζεται αυτό το πρότυπο στο WhatsApp.",
      "OPEN": "Προεπισκόπηση {name}",
      "CLOSE": "Κλείσιμο προεπισκόπησης",
      "DETAILS": "Λεπτομέρειες προτύπου",
      "STATUS": "Κατάσταση",
      "TYPE": "Τύπος περιεχομένου",
      "CATEGORY": "Κατηγορία",
      "LANGUAGE": "Γλώσσα",
      "INBOXES": "Κιβώτια"
    }
  }
}
